import { type WithID } from '@ps/models/lib/base';
import 'client-only';
import type { DocumentSnapshot } from 'firebase/firestore';

export const snapshotToDataWithId = <T>(
  snapshot: DocumentSnapshot | null | undefined,
): WithID<T> | undefined => {
  return snapshot != null && snapshot.exists()
    ? { ...(snapshot.data() as any), id: snapshot.id }
    : undefined;
};
